(function () {
  'use strict';

  var NV = window.NV || {};

  /* ── helpers ─────────────────────────────────── */
  function money(cents) {
    var fmt = NV.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  function toast(message) {
    var el = document.getElementById('nv-toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(el._t);
    el._t = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 250);
    }, 2600);
  }

  function trapFocus(container) {
    var sel = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(container.querySelectorAll(sel), function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ── cart ────────────────────────────────────── */
  var Cart = {
    fetchState: function () {
      return fetch(NV.routes.cart, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    },

    add: function (id, quantity) {
      return fetch(NV.routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
          return data;
        });
      });
    },

    change: function (line, quantity) {
      return fetch(NV.routes.cart_change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); });
    },

    refresh: function () {
      return Cart.fetchState().then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('nv:cart:updated', { detail: cart }));
        return cart;
      });
    },

    renderDrawer: function () {
      return fetch(window.location.pathname + '?section_id=nv-cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-cart-drawer-contents]');
          var current = document.querySelector('[data-cart-drawer-contents]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
    }
  };

  /* ── drawer (cart + menu) ────────────────────── */
  function Drawer(root) {
    if (!root || root._nvBound) return;
    root._nvBound = true;
    var panel = root.querySelector('[data-drawer-panel]');
    var scrim = root.querySelector('[data-drawer-scrim]');
    var opener = null;

    function open(trigger) {
      opener = trigger || document.activeElement;
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var focusable = panel && panel.querySelector('[data-drawer-close]');
      if (focusable) focusable.focus();
    }

    function close() {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () { root.hidden = true; }, 300);
      if (opener && document.contains(opener)) opener.focus();
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]') || e.target === scrim) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    if (panel) trapFocus(panel);

    root._open = open;
    root._close = close;
  }

  function openDrawerById(id, trigger) {
    var root = document.getElementById(id);
    if (!root) return false;
    Drawer(root);
    root._open(trigger);
    return true;
  }

  /* ── boot ────────────────────────────────────── */
  function init() {
    document.querySelectorAll('[data-drawer]').forEach(Drawer);

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-drawer-open]');
      if (openBtn) {
        var id = openBtn.getAttribute('data-drawer-open');
        if (openDrawerById(id, openBtn)) e.preventDefault();
        return;
      }

      var qa = e.target.closest('[data-quick-add]');
      if (qa) {
        e.preventDefault();
        var vid = qa.getAttribute('data-quick-add');
        var original = qa.textContent;
        qa.disabled = true;
        Cart.add(vid, 1)
          .then(function () { return Cart.refresh(); })
          .then(function () {
            qa.textContent = NV.strings.added;
            toast(NV.strings.added);
            if (NV.cartDrawer) { return Cart.renderDrawer().then(function () { openDrawerById('nv-cart-drawer', qa); }); }
          })
          .catch(function (err) { toast(err.message); })
          .finally(function () {
            setTimeout(function () { qa.textContent = original; qa.disabled = false; }, 1600);
          });
      }

      var rm = e.target.closest('[data-cart-remove]');
      if (rm) {
        e.preventDefault();
        Cart.change(parseInt(rm.getAttribute('data-cart-remove'), 10), 0)
          .then(function () { return Cart.refresh(); })
          .then(function () { return NV.cartDrawer ? Cart.renderDrawer() : window.location.reload(); });
      }
    });

    /* quantity steppers */
    document.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (!step) return;
      var wrap = step.closest('[data-qty]');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var delta = step.getAttribute('data-qty-step') === 'up' ? 1 : -1;
      var next = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) + delta);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* cart line quantity changes */
    document.addEventListener('change', function (e) {
      var line = e.target.closest('[data-cart-line]');
      if (!line) return;
      Cart.change(parseInt(line.getAttribute('data-cart-line'), 10), parseInt(e.target.value, 10))
        .then(function () { return Cart.refresh(); })
        .then(function () { return NV.cartDrawer ? Cart.renderDrawer() : window.location.reload(); });
    });

    /* product forms */
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!NV.cartDrawer) return;
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var idField = form.querySelector('[name="id"]');
        var qtyField = form.querySelector('[name="quantity"]');
        if (!idField) return;
        if (btn) btn.disabled = true;
        Cart.add(idField.value, qtyField ? parseInt(qtyField.value, 10) : 1)
          .then(function () { return Cart.refresh(); })
          .then(function () { return Cart.renderDrawer(); })
          .then(function () { openDrawerById('nv-cart-drawer', btn); })
          .catch(function (err) { toast(err.message); })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    });

    /* variant switching */
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var data = null;
      try { data = JSON.parse(picker.querySelector('[data-variant-json]').textContent); } catch (err) { return; }
      var form = document.getElementById(picker.getAttribute('data-form'));
      if (!form) return;

      picker.addEventListener('change', function () {
        var chosen = Array.prototype.map.call(picker.querySelectorAll('select, input:checked'), function (f) { return f.value; });
        var match = data.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
        var idField = form.querySelector('[name="id"]');
        var btn = form.querySelector('[type="submit"]');
        var priceEl = document.querySelector('[data-variant-price]');

        if (!match) {
          if (btn) { btn.disabled = true; btn.textContent = NV.strings.soldOut; }
          return;
        }
        if (idField) idField.value = match.id;
        if (btn) { btn.disabled = !match.available; btn.textContent = match.available ? NV.strings.addToCart : NV.strings.soldOut; }
        if (priceEl) {
          var html = '<span class="nv-price__now">' + money(match.price) + '</span>';
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html += '<s class="nv-price__was">' + money(match.compare_at_price) + '</s>';
            html += '<span class="nv-price__save">Save ' + money(match.compare_at_price - match.price) + '</span>';
          }
          priceEl.innerHTML = html;
        }
        if (match.image) {
          var main = document.querySelector('[data-gallery-main] img');
          if (main) main.src = match.image;
        }
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      });
    });

    /* gallery thumbs */
    document.querySelectorAll('[data-gallery]').forEach(function (gal) {
      gal.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-gallery-thumb]');
        if (!thumb) return;
        var main = gal.querySelector('[data-gallery-main] img');
        var img = thumb.querySelector('img');
        if (main && img) main.src = img.getAttribute('data-full') || img.src;
        gal.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* localization selects submit on change */
    document.querySelectorAll('[data-localization-form] select').forEach(function (sel) {
      sel.addEventListener('change', function () { sel.form.submit(); });
    });

    Cart.refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.NV.cart = Cart;
  window.NV.toast = toast;
})();
